/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'welcome';
const componentName = 'modal-container';
const prefix = `${moduleName}.${componentName}`;

export const cancelBtnLabel = `${prefix}.cancelBtnLabel`;
export const saveBtnLabel = `${prefix}.saveBtnLabel`;

export const ENGLISH = {
    [cancelBtnLabel]: 'Cancel',
    [saveBtnLabel]: 'Save',
};
